var installedModules = {};
var moduleToHandlerMapping = {
	9340: {
		getter: function() { return __webpack_require__.e(368).then(function() { return function() { return __webpack_require__(3368); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	297: {
		getter: function() { return Promise.all([__webpack_require__.e(519), __webpack_require__.e(884), __webpack_require__.e(715), __webpack_require__.e(442)]).then(function() { return function() { return __webpack_require__(6715); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/router",
	},
	2088: {
		getter: function() { return Promise.all([__webpack_require__.e(519), __webpack_require__.e(725)]).then(function() { return function() { return __webpack_require__(1106); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	3606: {
		getter: function() { return Promise.all([__webpack_require__.e(884), __webpack_require__.e(442), __webpack_require__.e(165)]).then(function() { return function() { return __webpack_require__(8133); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	},
	2650: {
		getter: function() { return Promise.all([__webpack_require__.e(965), __webpack_require__.e(442)]).then(function() { return function() { return __webpack_require__(9965); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/image",
	},
	2462: {
		getter: function() { return __webpack_require__.e(953).then(function() { return function() { return __webpack_require__(4953); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	8775: {
		getter: function() { return __webpack_require__.e(593).then(function() { return function() { return __webpack_require__(4848); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react/jsx-runtime",
	},
	2342: {
		getter: function() { return function() { return __webpack_require__(6540); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	4072: {
		getter: function() { return __webpack_require__.e(816).then(function() { return function() { return __webpack_require__(4435); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx",
	},
	5061: {
		getter: function() { return __webpack_require__.e(513).then(function() { return function() { return __webpack_require__(2513); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx/style",
	},
	9601: {
		getter: function() { return function() { return __webpack_require__(5852); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "11.11.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@emotion/cache",
	},
	4007: {
		getter: function() { return function() { return __webpack_require__(196); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "11.10.8",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@emotion/react",
	},
	2115: {
		getter: function() { return __webpack_require__.e(593).then(function() { return function() { return __webpack_require__(5338); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom/client",
	},
	4442: {
		getter: function() { return function() { return __webpack_require__(961); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	5854: {
		getter: function() { return __webpack_require__.e(953).then(function() { return function() { return __webpack_require__(4953); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^14.2.23",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	412: {
		getter: function() { return __webpack_require__.e(368).then(function() { return function() { return __webpack_require__(3368); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^14.2.23",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	3254: {
		getter: function() { return __webpack_require__.e(133).then(function() { return function() { return __webpack_require__(8133); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^14.2.23",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	},
	7144: {
		getter: function() { return function() { return __webpack_require__(5879); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "11.10.8",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@emotion/styled",
	},
	9960: {
		getter: function() { return __webpack_require__.e(106).then(function() { return function() { return __webpack_require__(1106); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^14.2.23",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	}
};
var initialConsumes = [9340,297,2088,3606,2650,2462,8775,2342,4072,5061,9601,4007,8775,2342,2115,4442,9601,4007,297,5854];
__webpack_require__.federation.installInitialConsumes = function() { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}); }
var chunkMapping = {
	"442": [
		4442
	],
	"527": [
		9340,
		297,
		2088,
		3606,
		2650,
		2462,
		8775,
		2342,
		4072,
		5061,
		9601,
		4007
	],
	"556": [
		412,
		3254,
		7144,
		9960
	],
	"636": [
		297
	],
	"792": [
		8775,
		2342,
		2115,
		4442,
		9601,
		4007
	],
	"854": [
		5854
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}